webpackJsonp([8],{

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Banner__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Info__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Mission__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_ExploreCourse__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Meta__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_LazyComponent__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_css__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_css__);
var AboutUs=function AboutUs(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('main',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Meta__["a" /* default */],{title:'About Us | Alien Brains Educations',description:'Alien Brains Educations is one of the premier institutes having classroom like mentorship program for summer and winter online training programs under industry professionals.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Banner__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_LazyComponent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Info__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_LazyComponent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Mission__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_LazyComponent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_ExploreCourse__["a" /* default */],null)));};/* harmony default export */ __webpack_exports__["default"] = (AboutUs);

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Image__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_css__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ImageBlurFallback=function(_React$PureComponent){_inherits(ImageBlurFallback,_React$PureComponent);function ImageBlurFallback(props){_classCallCheck(this,ImageBlurFallback);var _this=_possibleConstructorReturn(this,(ImageBlurFallback.__proto__||Object.getPrototypeOf(ImageBlurFallback)).call(this,props));_this.onImageLoad=function(){var onLoad=_this.props.onLoad;_this.setState({isLoaded:true});if(typeof onLoad==='function'){onLoad();}};_this.state={isLoaded:false};return _this;}_createClass(ImageBlurFallback,[{key:'render',value:function render(){var _props=this.props,className=_props.className,onLoad=_props.onLoad,fallbackImage=_props.fallbackImage,src=_props.src,otherProps=_objectWithoutProperties(_props,['className','onLoad','fallbackImage','src']);var isLoaded=this.state.isLoaded;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:(isLoaded?'visible-fallback':'blur-fallback')+' '+className},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Image__["a" /* default */],Object.assign({},otherProps,{className:className,src:src,onLoad:this.onImageLoad})),!isLoaded&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{style:{backgroundImage:!fallbackImage?'linear-gradient(45deg, #ebedee, #bdc3c7)':'',animation:!fallbackImage?'dim 3s ease infinite':''},className:'Image-fallback'},!!fallbackImage&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Image__["a" /* default */],{className:className,src:fallbackImage})));}}]);return ImageBlurFallback;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);ImageBlurFallback.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onLoad:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,fallbackImage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};ImageBlurFallback.defaultProps={onLoad:function onLoad(){},fallbackImage:''};/* harmony default export */ __webpack_exports__["a"] = (ImageBlurFallback);

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(269);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":false}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(226)(content, options);
if(content.locals) module.exports = content.locals;


/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(225)(true);
// imports


// module
exports.push([module.i, ".blur-fallback{width:100%;height:100%;-webkit-filter:blur(10px);filter:blur(10px);-webkit-box-sizing:border-box;box-sizing:border-box}.blur-fallback,.visible-fallback{position:relative;overflow:hidden}.visible-fallback{width:auto;height:auto}.Image-fallback{position:absolute;top:0;right:0;bottom:0;left:0;z-index:100;background-size:400%;width:auto!important;height:auto!important;max-width:100%!important;max-height:100%!important;margin:0!important;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}", "", {"version":3,"sources":["/Users/sourabhkumarbanka/dev/alienbrains_main_website/src/Components/ImageBlurFallback/style.css"],"names":[],"mappings":"AAAA,eACE,WAAY,AACZ,YAAa,AACb,0BAA2B,AAC3B,kBAAmB,AAEnB,8BAA+B,AACvB,qBAAuB,CAEhC,AAED,iCANE,kBAAmB,AAGnB,eAAiB,CAQlB,AALD,kBACE,WAAY,AACZ,WAAa,CAGd,AAED,gBACE,kBAAmB,AACnB,MAAS,AACT,QAAW,AACX,SAAY,AACZ,OAAU,AACV,YAAa,AACb,qBAAsB,AACtB,qBAAuB,AACvB,sBAAwB,AACxB,yBAA2B,AAC3B,0BAA4B,AAC5B,mBAAuB,AACvB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,uBAAwB,AAC5B,sBAAuB,AACnB,kBAAoB,CACzB","file":"style.css","sourcesContent":[".blur-fallback {\n  width: 100%;\n  height: 100%;\n  -webkit-filter: blur(10px);\n  filter: blur(10px);\n  position: relative;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  overflow: hidden;\n}\n\n.visible-fallback {\n  width: auto;\n  height: auto;\n  position: relative;\n  overflow: hidden;\n}\n\n.Image-fallback {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  z-index: 100;\n  background-size: 400%;\n  width: auto !important;\n  height: auto !important;\n  max-width: 100% !important;\n  max-height: 100% !important;\n  margin: 0px !important;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_css__);
var Heading=function Heading(props){var _props$className=props.className,className=_props$className===undefined?'':_props$className;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'heading-row '+className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,props.title));};/* harmony default export */ __webpack_exports__["a"] = (Heading);

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Assets_v2_Meta_ogImageSmall_jpg__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Assets_v2_Meta_ogImageSmall_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Assets_v2_Meta_ogImageSmall_jpg__);
var Meta=function Meta(_ref){var title=_ref.title,description=_ref.description,link=_ref.link,keywords=_ref.keywords;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet__["a" /* Helmet */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'title',content:title}),link&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('link',{rel:'canonical',href:link}),description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'description',content:description}),keywords&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'keywords',content:keywords}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{property:'og:site_name',content:'Alien Brains Educations'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{property:'og:title',content:title}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{property:'og:description',content:description}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{property:'og:url',content:window.location.href}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{property:'og:type',content:'website'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{property:'og:image',itemProp:'image',content:__WEBPACK_IMPORTED_MODULE_3__Assets_v2_Meta_ogImageSmall_jpg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{property:'og:image:width',content:'300'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{property:'og:image:height',content:'300'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{property:'og:image:type',content:'image/jpg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'twitter:title',content:title}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'twitter:card',content:'summary'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'twitter:description',content:description}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'twitter:image',content:__WEBPACK_IMPORTED_MODULE_3__Assets_v2_Meta_ogImageSmall_jpg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{itemprop:'name',content:title}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{itemprop:'description',content:description}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{itemprop:'image',content:__WEBPACK_IMPORTED_MODULE_3__Assets_v2_Meta_ogImageSmall_jpg___default.a}));};Meta.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Meta);

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HelmetExport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_side_effect__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_side_effect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_side_effect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fast_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_assign__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_object_assign__);






var ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};

var REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = "data-react-helmet";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === TAG_PROPERTIES.INNER_HTML || attributeKey === TAG_PROPERTIES.CSS_TEXT || attributeKey === TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = __WEBPACK_IMPORTED_MODULE_4_object_assign___default()({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([TAG_PROPERTIES.HREF, TAG_PROPERTIES.TARGET], propsList),
        bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [TAG_PROPERTIES.REL, TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(TAG_NAMES.META, [TAG_PROPERTIES.NAME, TAG_PROPERTIES.CHARSET, TAG_PROPERTIES.HTTPEQUIV, TAG_PROPERTIES.PROPERTY, TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [TAG_PROPERTIES.SRC, TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case ATTRIBUTE_NAMES.BODY:
        case ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            classCallCheck(this, HelmetWrapper);
            return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !__WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default()(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case TAG_NAMES.SCRIPT:
                case TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _babelHelpers$extends));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));

                case TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _babelHelpers$extends4;

                newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return warn("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return warn("Only elements types " + VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = convertReactPropstoHtmlAttributes(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case TAG_NAMES.LINK:
                    case TAG_NAMES.META:
                    case TAG_NAMES.NOSCRIPT:
                    case TAG_NAMES.SCRIPT:
                    case TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, newProps);
        };

        createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set$$1(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);
        return HelmetWrapper;
    }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component), _class.propTypes = {
        base: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        bodyAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node]),
        defaultTitle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        defer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        encodeSpecialCharacters: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        htmlAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        link: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        meta: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        noscript: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        onChangeClientState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
        script: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        titleAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        titleTemplate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = mapStateOnServer({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = __WEBPACK_IMPORTED_MODULE_1_react_side_effect___default()(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

/* unused harmony default export */ var _unused_webpack_default_export = (HelmetExport);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = /*#__PURE__*/function (_PureComponent) {
      _inheritsLoose(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return /*#__PURE__*/React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.PureComponent);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),

/***/ 278:
/***/ (function(module, exports) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ogImageSmall.6e4dabe0.jpg";

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LazyComponent=function(_React$PureComponent){_inherits(LazyComponent,_React$PureComponent);function LazyComponent(props){_classCallCheck(this,LazyComponent);var _this=_possibleConstructorReturn(this,(LazyComponent.__proto__||Object.getPrototypeOf(LazyComponent)).call(this,props));_this.render=function(){var isVisible=_this.state.isVisible;var children=_this.props.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'lazy-container',ref:function ref(r){_this.ref=r;},style:{width:'auto',height:isVisible?'auto':'300px'}},isVisible?children:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'fallback'}));};_this.state={isVisible:false};_this.ref=__WEBPACK_IMPORTED_MODULE_0_react__["createRef"]();return _this;}_createClass(LazyComponent,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var options={rootMargin:'0px',threshold:0.3};var observer=new IntersectionObserver(function(entries){if(entries&&entries.length>0&&entries[0].isIntersecting){_this2.setState({isVisible:true});observer.unobserve(_this2.ref);}},options);observer.observe(this.ref);}}]);return LazyComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (LazyComponent);

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(296);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":false}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(226)(content, options);
if(content.locals) module.exports = content.locals;


/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(225)(true);
// imports


// module
exports.push([module.i, ".fallback{width:100%;height:300px;-webkit-filter:blur(20px);filter:blur(20px)}.lazy-container{-webkit-transition:all .3s ease;-o-transition:all ease .3s;transition:all .3s ease}", "", {"version":3,"sources":["/Users/sourabhkumarbanka/dev/alienbrains_main_website/src/Components/LazyComponent/style.css"],"names":[],"mappings":"AAAA,UACE,WAAY,AACZ,aAAc,AACd,0BAA2B,AACnB,iBAAmB,CAC5B,AAED,gBACE,gCAAkC,AAClC,2BAA6B,AAC7B,uBAA0B,CAC3B","file":"style.css","sourcesContent":[".fallback {\n  width: 100%;\n  height: 300px;\n  -webkit-filter: blur(20px);\n          filter: blur(20px);\n}\n\n.lazy-container {\n  -webkit-transition: all ease 0.3s;\n  -o-transition: all ease 0.3s;\n  transition: all ease 0.3s;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(327);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":false}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(226)(content, options);
if(content.locals) module.exports = content.locals;


/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(225)(true);
// imports


// module
exports.push([module.i, ".heading-row{width:100%;min-height:100px;height:auto;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;color:#000;text-transform:uppercase}.heading-row span{font-weight:bolder;font-size:var(--large-text)!important}", "", {"version":3,"sources":["/Users/sourabhkumarbanka/dev/alienbrains_main_website/src/Components/Heading/style.css"],"names":[],"mappings":"AAAA,aACE,WAAY,AACZ,iBAAkB,AAClB,YAAa,AACb,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,uBAAwB,AAC5B,sBAAuB,AACnB,mBAAoB,AACxB,WAAa,AACb,wBAA0B,CAC3B,AAED,kBACE,mBAAoB,AACpB,qCAAwC,CACzC","file":"style.css","sourcesContent":[".heading-row {\n  width: 100%;\n  min-height: 100px;\n  height: auto;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  color: black;\n  text-transform: uppercase;\n}\n\n.heading-row span {\n  font-weight: bolder;\n  font-size: var(--large-text) !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 377:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Overlay__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_css__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_css__);
//  $Ignore
var ExploreCourses=function ExploreCourses(_ref){var _ref$title=_ref.title,title=_ref$title===undefined?'':_ref$title,_ref$description=_ref.description,description=_ref$description===undefined?'':_ref$description,_ref$actionText=_ref.actionText,actionText=_ref$actionText===undefined?'':_ref$actionText,_ref$onClick=_ref.onClick,onClick=_ref$onClick===undefined?'':_ref$onClick,history=_ref.history;var _useTranslation=Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])(),t=_useTranslation.t;var newTitle=title||t('explorecourseHeading');var newDescription=description||t('explorecoursePara');var newActionText=actionText||t('explorecourseLink');var onButtonClick=onClick||function click(){history.push('/live_classes');};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'explore-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_Overlay__["a" /* default */],{className:'explore-overlay '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'explore-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'explore-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,newTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,newDescription)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'explore-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Button__["a" /* default */],{onClick:onButtonClick,text:newActionText})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(ExploreCourses));

/***/ }),

/***/ 378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_css__);
var Overlay=function Overlay(props){var _props$className=props.className,className=_props$className===undefined?'':_props$className;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:className+' overlay-content'},props.children);};Overlay.defaultProps={className:''};/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(380);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":false}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(226)(content, options);
if(content.locals) module.exports = content.locals;


/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(225)(true);
// imports


// module
exports.push([module.i, ".overlay-content{position:absolute;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.7)}", "", {"version":3,"sources":["/Users/sourabhkumarbanka/dev/alienbrains_main_website/src/Components/Overlay/style.css"],"names":[],"mappings":"AAAA,iBACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,+BAAqC,CACtC","file":"style.css","sourcesContent":[".overlay-content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(382);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":false}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(226)(content, options);
if(content.locals) module.exports = content.locals;


/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(225)(true);
// imports


// module
exports.push([module.i, ".explore-container{width:100%;height:auto;min-height:200px;background-image:url(\"https://images.unsplash.com/photo-1555421689-491a97ff2040?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80\");background-size:cover;background-position:50%;position:relative}.explore-content{width:100%;min-height:150px;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:stretch;align-items:stretch}.explore-content,.explore-overlay{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}.explore-overlay{background:rgba(253,205,0,.8);-ms-flex-align:center;align-items:center;text-align:left}.explore-left{-ms-flex-preferred-size:60%;flex-basis:60%;min-width:300px;display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:start;align-items:flex-start}.explore-left span{font-size:var(--normal-text);font-weight:bolder}.explore-left p{font-size:var(--medium-text);font-weight:900;margin:5px 0}.explore-right{-ms-flex-preferred-size:68%;flex-basis:68%;margin-top:10px;-ms-flex-pack:start;justify-content:flex-start}.explore-right,.explore-right>button{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.explore-right>button{-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12);box-shadow:0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12);width:250px;height:50px;-ms-flex-pack:center;justify-content:center;background-color:#fff;text-decoration:none;border-radius:5px;color:#000;font-weight:800}@media (min-width:450px){.explore-content{-ms-flex-pack:distribute;justify-content:space-around}.explore-left{-ms-flex-preferred-size:40%;flex-basis:40%;-ms-flex-pack:center;justify-content:center;-ms-flex-align:start;align-items:flex-start}.explore-right{-ms-flex-preferred-size:20%;flex-basis:20%;-ms-flex-pack:end;justify-content:flex-end;margin-top:0}.explore-right>button{width:150px}}@media (min-width:768px){.explore-right>button{width:250px}.explore-content{-ms-flex-pack:justify;justify-content:space-between;max-width:80%}.explore-left{-ms-flex-preferred-size:50%;flex-basis:50%;-ms-flex-pack:center;justify-content:center;-ms-flex-align:start;align-items:flex-start}.explore-right{-ms-flex-preferred-size:30%;flex-basis:30%;-ms-flex-pack:end;justify-content:flex-end;margin-top:0}}@media (min-width:1024px){.explore-content{max-width:85%}}", "", {"version":3,"sources":["/Users/sourabhkumarbanka/dev/alienbrains_main_website/src/Components/ExploreCourse/style.css"],"names":[],"mappings":"AAAA,mBACE,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,4JAA6J,AAC7J,sBAAuB,AACvB,wBAA4B,AAE5B,iBAAmB,CACpB,AAED,iBACE,WAAY,AAGZ,iBAAkB,AAElB,uBAAwB,AACpB,mBAAoB,AAGxB,uBAAwB,AACpB,mBAAqB,CAC1B,AAED,kCAZE,oBAAqB,AAGrB,aAAc,AAGd,qBAAsB,AAClB,sBAAwB,CAc7B,AATD,iBACE,8BAAmC,AAKnC,sBAAuB,AACnB,mBAAoB,AACxB,eAAiB,CAClB,AAED,cACE,4BAA6B,AACzB,eAAgB,AACpB,gBAAiB,AACjB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AACzB,wBAAyB,AAC7B,oBAAqB,AACjB,2BAA4B,AAChC,qBAAsB,AAClB,sBAAwB,CAC7B,AAED,mBACE,6BAA8B,AAC9B,kBAAoB,CACrB,AACD,gBACE,6BAA8B,AAC9B,gBAAiB,AACjB,YAAc,CACf,AACD,eACE,4BAA6B,AACzB,eAAgB,AACpB,gBAAiB,AAGjB,oBAAqB,AACjB,0BAA4B,CAGjC,AAED,qCARE,oBAAqB,AACrB,aAAc,AAGd,sBAAuB,AACnB,kBAAoB,CAmBzB,AAhBD,sBACE,4EAAsF,AAC9E,oEAA8E,AACtF,YAAa,AACb,YAAa,AAGb,qBAAsB,AAClB,uBAAwB,AAG5B,sBAAwB,AACxB,qBAAsB,AACtB,kBAAmB,AACnB,WAAa,AACb,eAAiB,CAClB,AAED,yBACE,iBACE,yBAA0B,AACtB,4BAA8B,CACnC,AACD,cACE,4BAA6B,AACzB,eAAgB,AACpB,qBAAsB,AAClB,uBAAwB,AAC5B,qBAAsB,AAClB,sBAAwB,CAC7B,AACD,eACE,4BAA6B,AACzB,eAAgB,AACpB,kBAAmB,AACf,yBAA0B,AAC9B,YAAgB,CACjB,AAED,sBACE,WAAa,CACd,CACF,AAED,yBACE,sBACE,WAAa,CACd,AACD,iBACE,sBAAuB,AACnB,8BAA+B,AAGnC,aAAe,CAFhB,AAKD,cACE,4BAA6B,AACzB,eAAgB,AACpB,qBAAsB,AAClB,uBAAwB,AAC5B,qBAAsB,AAClB,sBAAwB,CAC7B,AACD,eACE,4BAA6B,AACzB,eAAgB,AACpB,kBAAmB,AACf,yBAA0B,AAC9B,YAAgB,CACjB,CACF,AAED,0BACE,iBACE,aAAe,CAChB,CACF","file":"style.css","sourcesContent":[".explore-container {\n  width: 100%;\n  height: auto;\n  min-height: 200px;\n  background-image: url('https://images.unsplash.com/photo-1555421689-491a97ff2040?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80');\n  background-size: cover;\n  background-position: center;\n\n  position: relative;\n}\n\n.explore-content {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  min-height: 150px;\n  display: flex;\n  -ms-flex-flow: row wrap;\n      flex-flow: row wrap;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: stretch;\n      align-items: stretch;\n}\n\n.explore-overlay {\n  background: rgba(253, 205, 0, 0.8);\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  text-align: left;\n}\n\n.explore-left {\n  -ms-flex-preferred-size: 60%;\n      flex-basis: 60%;\n  min-width: 300px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: column nowrap;\n      flex-flow: column nowrap;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n  -ms-flex-align: start;\n      align-items: flex-start;\n}\n\n.explore-left span {\n  font-size: var(--normal-text);\n  font-weight: bolder;\n}\n.explore-left p {\n  font-size: var(--medium-text);\n  font-weight: 900;\n  margin: 5px 0;\n}\n.explore-right {\n  -ms-flex-preferred-size: 68%;\n      flex-basis: 68%;\n  margin-top: 10px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.explore-right > button {\n  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n          box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n  width: 250px;\n  height: 50px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  background-color: white;\n  text-decoration: none;\n  border-radius: 5px;\n  color: black;\n  font-weight: 800;\n}\n\n@media (min-width: 450px) {\n  .explore-content {\n    -ms-flex-pack: distribute;\n        justify-content: space-around;\n  }\n  .explore-left {\n    -ms-flex-preferred-size: 40%;\n        flex-basis: 40%;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: start;\n        align-items: flex-start;\n  }\n  .explore-right {\n    -ms-flex-preferred-size: 20%;\n        flex-basis: 20%;\n    -ms-flex-pack: end;\n        justify-content: flex-end;\n    margin-top: 0px;\n  }\n\n  .explore-right > button {\n    width: 150px;\n  }\n}\n\n@media (min-width: 768px) {\n  .explore-right > button {\n    width: 250px;\n  }\n  .explore-content {\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n  }\n  .explore-content {\n    max-width: 80%;\n  }\n\n  .explore-left {\n    -ms-flex-preferred-size: 50%;\n        flex-basis: 50%;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: start;\n        align-items: flex-start;\n  }\n  .explore-right {\n    -ms-flex-preferred-size: 30%;\n        flex-basis: 30%;\n    -ms-flex-pack: end;\n        justify-content: flex-end;\n    margin-top: 0px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .explore-content {\n    max-width: 85%;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Background.76084b2e.png";

/***/ }),

/***/ 423:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_css__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var HighlightInk=function HighlightInk(_ref){var children=_ref.children,otherProps=_objectWithoutProperties(_ref,['children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',Object.assign({className:'highlight-ink'},otherProps),children);};/* harmony default export */ __webpack_exports__["a"] = (HighlightInk);

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(425);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":false}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(226)(content, options);
if(content.locals) module.exports = content.locals;


/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(225)(true);
// imports


// module
exports.push([module.i, ".highlight-ink.highlight-ink{color:var(--medium-blue-color);font-weight:700;margin:0 5px}", "", {"version":3,"sources":["/Users/sourabhkumarbanka/dev/alienbrains_main_website/src/Components/HighlightInk/style.css"],"names":[],"mappings":"AAAA,6BACE,+BAAgC,AAChC,gBAAkB,AAClB,YAAc,CACf","file":"style.css","sourcesContent":[".highlight-ink.highlight-ink {\n  color: var(--medium-blue-color);\n  font-weight: bold;\n  margin: 0 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Heading__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_HighlightInk__ = __webpack_require__(423);
var Banner=function Banner(){var _useTranslation=Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])(),t=_useTranslation.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-banner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Components_Heading__["a" /* default */],{className:'about-banner-content-heading',title:t('bannerHeading')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('bannerPara1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('bannerPara2l1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_HighlightInk__["a" /* default */],null,t('bannerPara2l2')),t('bannerPara2l3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_HighlightInk__["a" /* default */],null,t('bannerPara2l4')),' ',t('bannerPara2l5')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('bannerPara3'))));};/* harmony default export */ __webpack_exports__["a"] = (Banner);

/***/ }),

/***/ 587:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InfoCard__ = __webpack_require__(588);
var Info=function Info(){var _useTranslation=Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])(),t=_useTranslation.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-info-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InfoCard__["a" /* default */],{title:t('infocard1Title'),text:t('infocard1Text')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InfoCard__["a" /* default */],{title:t('infocard2Title'),text:t('infocard2Text')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InfoCard__["a" /* default */],{title:t('infocard3Title'),text:t('infocard3Text')}));};/* harmony default export */ __webpack_exports__["a"] = (Info);

/***/ }),

/***/ 588:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var InfoCard=function InfoCard(props){var title=props.title,text=props.text;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"about-info-card"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dash"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,text));};/* harmony default export */ __webpack_exports__["a"] = (InfoCard);

/***/ }),

/***/ 589:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MissionContent__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Heading__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Assets_v2_about_Brain_jpg__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Assets_v2_about_Brain_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Assets_v2_about_Brain_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Assets_v2_about_Nutshell_png__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Assets_v2_about_Nutshell_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Assets_v2_about_Nutshell_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Assets_v2_about_Brain_webp__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Assets_v2_about_Brain_webp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Assets_v2_about_Brain_webp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Assets_v2_about_Nutshell_webp__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Assets_v2_about_Nutshell_webp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Assets_v2_about_Nutshell_webp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Assets_fallbacks_about_Brain_jpg__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Assets_fallbacks_about_Brain_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Assets_fallbacks_about_Brain_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Assets_fallbacks_about_Nutshell_jpg__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Assets_fallbacks_about_Nutshell_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Assets_fallbacks_about_Nutshell_jpg__);
var Mission=function Mission(){var _useTranslation=Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])(),t=_useTranslation.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-mission-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mission-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_Heading__["a" /* default */],{title:t('missionHeading')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__MissionContent__["a" /* default */],{fallbackImage:__WEBPACK_IMPORTED_MODULE_8__Assets_fallbacks_about_Brain_jpg___default.a,webpImage:__WEBPACK_IMPORTED_MODULE_6__Assets_v2_about_Brain_webp___default.a,image:__WEBPACK_IMPORTED_MODULE_4__Assets_v2_about_Brain_jpg___default.a,title:t('mission1Title'),text:t('mission1Text')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__MissionContent__["a" /* default */],{fallbackImage:__WEBPACK_IMPORTED_MODULE_9__Assets_fallbacks_about_Nutshell_jpg___default.a,webpImage:__WEBPACK_IMPORTED_MODULE_7__Assets_v2_about_Nutshell_webp___default.a,image:__WEBPACK_IMPORTED_MODULE_5__Assets_v2_about_Nutshell_png___default.a,title:t('mission2Title'),text:t('mission2Text')})));};/* harmony default export */ __webpack_exports__["a"] = (Mission);

/***/ }),

/***/ 590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_ImageBlurFallback__ = __webpack_require__(244);
var MissionContent=function MissionContent(props){var title=props.title,text=props.text,image=props.image,webpImage=props.webpImage,_props$fallbackImage=props.fallbackImage,fallbackImage=_props$fallbackImage===undefined?'':_props$fallbackImage;var _useTranslation=Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])(),t=_useTranslation.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mission-content-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mission-content-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Components_ImageBlurFallback__["a" /* default */],{fallbackImage:fallbackImage,className:'mission-content-left-img',webpImage:webpImage,src:image,alt:t('missioncontentImgAlt')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mission-content-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,title,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,text)));};/* harmony default export */ __webpack_exports__["a"] = (MissionContent);

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Brain.f52f5cc2.jpg";

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Nutshell.928b5c81.png";

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Brain.1155071f.webp";

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Nutshell.147661a2.webp";

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Nutshell.dd5ed641.jpg";

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(598);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":false}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(226)(content, options);
if(content.locals) module.exports = content.locals;


/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(225)(true);
// imports


// module
exports.push([module.i, ".about-banner{width:100%;height:auto;min-height:650px;background-image:url(" + __webpack_require__(385) + ");background-position:0;background-size:cover;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;text-align:left}.about-banner-content-heading{-ms-flex-pack:start;justify-content:flex-start}.about-banner-content{width:80%;-ms-flex-flow:column nowrap;flex-flow:column nowrap;font-weight:500;line-height:24px}.about-banner-content,.about-info-container{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.about-info-container{width:100%;height:auto;min-height:400px;-ms-flex-flow:row wrap;flex-flow:row wrap}.about-info-card{width:320px;height:300px;display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-ms-flex-pack:distribute;justify-content:space-around;-ms-flex-align:start;align-items:flex-start;padding:10px;border:1px solid rgba(0,0,0,.125);border-radius:10px;margin:10px;text-align:left}.about-info-card:hover{-webkit-box-shadow:2px 4px 7px 2px hsla(93,87%,85%,.16),2px 4px 12px 2px rgba(0,0,0,.12);box-shadow:2px 4px 7px 2px hsla(93,87%,85%,.16),2px 4px 12px 2px rgba(0,0,0,.12)}.about-info-card>p{font-size:var(--normal-text);font-weight:bolder}.about-info-card>span{font-size:var(--small-text);font-weight:600}.dash{width:100px;height:4px;background-color:blue}.about-mission-container{min-height:800px;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.about-mission-container,.mission-content-box{width:100%;height:auto;display:-ms-flexbox;display:flex}.mission-content-box{min-height:600px;-ms-flex-flow:row wrap;flex-flow:row wrap;margin:50px 0}.mission-content-left{-ms-flex:1 1;flex:1 1;min-width:300px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:start;align-items:flex-start}.mission-content-left-img{max-width:300px;-o-object-fit:contain;object-fit:contain}.mission-content-right{-ms-flex:1 1;flex:1 1;min-width:300px;display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;padding:30px;text-align:left}.mission-content-right>p{font-weight:700;font-size:var(--medium-text)}.mission-content-right>span{font-weight:500;line-height:25px;font-size:var(--normal-text)}@media (min-width:768px){.mission-content-right{-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:start;align-items:flex-start}}@media (min-width:1440px){.about-banner-content{width:60%}.mission-content{max-width:70%}.mission-content-left-img{max-width:400px}}", "", {"version":3,"sources":["/Users/sourabhkumarbanka/dev/alienbrains_main_website/src/Pages/AboutUs/style.css"],"names":[],"mappings":"AAAA,cACE,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,+CAAmE,AACnE,sBAA0B,AAC1B,sBAAuB,AACvB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,uBAAwB,AAC5B,sBAAuB,AACnB,mBAAoB,AACxB,eAAiB,CAClB,AAED,8BACE,oBAAqB,AACjB,0BAA4B,CACjC,AAED,sBACE,UAAW,AAGX,4BAA6B,AACzB,wBAAyB,AAK7B,gBAAiB,AACjB,gBAAkB,CACnB,AAED,4CAZE,oBAAqB,AACrB,aAAc,AAGd,qBAAsB,AAClB,uBAAwB,AAC5B,sBAAuB,AACnB,kBAAoB,CAiBzB,AAZD,sBACE,WAAY,AACZ,YAAa,AACb,iBAAkB,AAGlB,uBAAwB,AACpB,kBAAoB,CAKzB,AACD,iBACE,YAAa,AACb,aAAc,AACd,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AACzB,wBAAyB,AAC7B,yBAA0B,AACtB,6BAA8B,AAClC,qBAAsB,AAClB,uBAAwB,AAC5B,aAAc,AACd,kCAAuC,AACvC,mBAAoB,AACpB,YAAa,AACb,eAAiB,CAClB,AAED,uBACE,yFACuC,AAC/B,gFAC+B,CACxC,AAED,mBACE,6BAA8B,AAC9B,kBAAoB,CACrB,AAED,sBACE,4BAA6B,AAC7B,eAAiB,CAClB,AAED,MACE,YAAa,AACb,WAAY,AACZ,qBAAuB,CACxB,AAED,yBAGE,iBAAkB,AAGlB,qBAAsB,AAClB,uBAAwB,AAC5B,sBAAuB,AACnB,kBAAoB,CACzB,AACD,8CAVE,WAAY,AACZ,YAAa,AAEb,oBAAqB,AACrB,YAAc,CAef,AATD,qBAGE,iBAAkB,AAGlB,uBAAwB,AACpB,mBAAoB,AACxB,aAAe,CAChB,AAED,sBACE,aAAc,AACV,SAAU,AACd,gBAAiB,AACjB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,uBAAwB,AAC5B,qBAAsB,AAClB,sBAAwB,CAC7B,AAED,0BACE,gBAAiB,AACjB,sBAAuB,AACpB,kBAAoB,CACxB,AACD,uBACE,aAAc,AACV,SAAU,AACd,gBAAiB,AACjB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AACzB,wBAAyB,AAC7B,qBAAsB,AAClB,uBAAwB,AAC5B,sBAAuB,AACnB,mBAAoB,AACxB,aAAc,AACd,eAAiB,CAClB,AAED,yBACE,gBAAkB,AAClB,4BAA8B,CAC/B,AAED,4BACE,gBAAiB,AACjB,iBAAkB,AAClB,4BAA8B,CAC/B,AACD,yBACE,uBACE,oBAAqB,AACjB,2BAA4B,AAChC,qBAAsB,AAClB,sBAAwB,CAC7B,CACF,AAED,0BACE,sBACE,SAAW,CACZ,AACD,iBACE,aAAe,CAChB,AAED,0BACE,eAAiB,CAClB,CACF","file":"style.css","sourcesContent":[".about-banner {\n  width: 100%;\n  height: auto;\n  min-height: 650px;\n  background-image: url('../../Assets/v2/Background/Background.png');\n  background-position: left;\n  background-size: cover;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  text-align: left;\n}\n\n.about-banner-content-heading {\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n}\n\n.about-banner-content {\n  width: 80%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: column nowrap;\n      flex-flow: column nowrap;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n.about-info-container {\n  width: 100%;\n  height: auto;\n  min-height: 400px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: row wrap;\n      flex-flow: row wrap;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.about-info-card {\n  width: 320px;\n  height: 300px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: column nowrap;\n      flex-flow: column nowrap;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  -ms-flex-align: start;\n      align-items: flex-start;\n  padding: 10px;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  border-radius: 10px;\n  margin: 10px;\n  text-align: left;\n}\n\n.about-info-card:hover {\n  -webkit-box-shadow: 2px 4px 7px 2px hsla(93, 87%, 85%, 0.16),\n    2px 4px 12px 2px rgba(0, 0, 0, 0.12);\n          box-shadow: 2px 4px 7px 2px hsla(93, 87%, 85%, 0.16),\n    2px 4px 12px 2px rgba(0, 0, 0, 0.12);\n}\n\n.about-info-card > p {\n  font-size: var(--normal-text);\n  font-weight: bolder;\n}\n\n.about-info-card > span {\n  font-size: var(--small-text);\n  font-weight: 600;\n}\n\n.dash {\n  width: 100px;\n  height: 4px;\n  background-color: blue;\n}\n\n.about-mission-container {\n  width: 100%;\n  height: auto;\n  min-height: 800px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.mission-content-box {\n  width: 100%;\n  height: auto;\n  min-height: 600px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: row wrap;\n      flex-flow: row wrap;\n  margin: 50px 0;\n}\n\n.mission-content-left {\n  -ms-flex: 1 1;\n      flex: 1 1;\n  min-width: 300px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: start;\n      align-items: flex-start;\n}\n\n.mission-content-left-img {\n  max-width: 300px;\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n.mission-content-right {\n  -ms-flex: 1 1;\n      flex: 1 1;\n  min-width: 300px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: column nowrap;\n      flex-flow: column nowrap;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 30px;\n  text-align: left;\n}\n\n.mission-content-right > p {\n  font-weight: bold;\n  font-size: var(--medium-text);\n}\n\n.mission-content-right > span {\n  font-weight: 500;\n  line-height: 25px;\n  font-size: var(--normal-text);\n}\n@media (min-width: 768px) {\n  .mission-content-right {\n    -ms-flex-pack: start;\n        justify-content: flex-start;\n    -ms-flex-align: start;\n        align-items: flex-start;\n  }\n}\n\n@media (min-width: 1440px) {\n  .about-banner-content {\n    width: 60%;\n  }\n  .mission-content {\n    max-width: 70%;\n  }\n\n  .mission-content-left-img {\n    max-width: 400px;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/8.77a7c492.chunk.js